module.exports = "/fonts/science.svg?101308897373c8fbf391e50761f4ef0b";


//////////////////
// WEBPACK FOOTER
// ./public/img/icons/science.svg
// module id = gMNz
// module chunks = 3